module.exports = __webpack_public_path__ + "static/media/511JamesPBrawleyDrNW_2018-06-12_90.08b232dd.jpg";